import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { BrainEstreamComputeService } from 'brain-data/service/brain-estream/brain-estream-compute.service';
import {
  loadEstreamCompute,
  loadEstreamComputeError,
  loadEstreamComputeSuccess,
} from '../actions/estream-compute.action';

@Injectable()
export class EstreamComputeEffects {
  loadEstreamCompute$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEstreamCompute),
      mergeMap(({ request }) =>
        this.service.compute(request).pipe(
          map(response => loadEstreamComputeSuccess({ request, response })),
          catchError((error: Error) => of(loadEstreamComputeError({ request, error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: BrainEstreamComputeService,
  ) {}
}
